// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FQVYQ","name":"styles_name__3TGg4","phone":"styles_phone__Y41cE"};